<template>
  <form id="frm_action" ref="formAction">
    <div class="p-formgrid">
      <div class="">
        <div class="" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
          <label class="txt-right required">Công ty</label>
          <DropdownScrollable cusClass="text-box m-0" :loading="loading" width="100%" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="items" :total="total" @keyup="emitEvent" @offset="changeOffset" :disabled="mode=='edit'"/>
          <input class="input_tmp_validator" id="company" />
        </div>
        <div v-show="company_id">
          <div class="mt-3">
            <span class="txt-last-update">Vui lòng chọn tối thiểu 1 biến số để cấu hình công thức tính rủi ro:</span>
            <div class="text-box row">
              <div class="col-6 mb-2" v-for="item, index in criteria" :key="`${item.id}-${index}`">
                <Checkbox v-model="tick_arr[item.id]" :binary="true" @click="checkBoxEvent(item, $event)"/>{{ item.code }}
              </div>
              <input class="input_tmp_validator" id="tick" />
            </div>
          </div>
          <div class="mt-3">
            <label class="txt-right">Công thức tính rủi ro (Risk - R)</label>
            <InputText
                v-model="formula"
                class="text-box input-text-box"
                placeholder="Nhập"
                :disabled="true"
              />
          </div>
          <div class="mt-3">
            <h5>XÁC ĐỊNH RỦI RO</h5>
          </div>
          <div class="mt-3">
            <div class="d-flex align-items-center mt-3">
              <RadioButton id="type1" name="type" value="POINT" v-model="type" />
              <label for="type1" class="mb-0">Theo thang điểm</label>
            </div>
            <div class="d-flex align-items-center mt-3">
              <RadioButton id="type2" name="type" value="MATRIX" v-model="type" :disabled="code_exist.length != 2 || count_total_select > 5" />
              <label for="type2" class="mb-0">Theo ma trận</label>
            </div>
            <span class="txt-last-update ml-4-5">Điều kiện: Có đủ 2 tiêu chí, mỗi tiêu chí &lt;= 5 mức độ.</span>
          </div>
          <div v-if="type == 'POINT'">
            <pointComponent v-model="points" :show="true" :company_id="company.id" :key="`point-${componentKey}`"/>
          </div>
          <div v-if="type == 'MATRIX'">
            <matrixComponent v-model="matrix" :show="true" :dataColor.sync="dataColor" :company_id="company.id" :formula="value" :listUid="code_exist" :key="`matrix-${componentKey}`" @matrix_rowcol="matrixRowCol" @matrix_color="matrixColor"/>
          </div>
        </div>
      </div>

      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          
          <Button
            v-if="$store.getters.controllers?.formula && $store.getters.controllers?.formula.includes('recalculation')"
            label="Tính toán lại toàn bộ dữ liệu theo công thức này"
            @click="saveData(true)"
            class="p-button-success main-style-outline-button" />
          <Button
            v-if="$store.getters.controllers?.formula && $store.getters.controllers?.formula.includes('edit')"
            label="Áp dụng ngay"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
    <Dialog header="Cảnh báo" :visible.sync="warningPopup" :containerStyle="{width: '350px'}" :modal="true">
      <div class="confirmation-content d-flex align-items-center">
          <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
          <span>Bạn đang chọn theo ma trận không thể thêm/bớt biến số, vui lòng thử lại.</span>
      </div>
    </Dialog>

    <Dialog header="Cảnh báo" :visible.sync="showWarningPoints" id="warning_poins_errs" :closable="false" :containerStyle="{width: '350px'}" :modal="true">
      <div class="confirmation-content d-flex align-items-center">
          <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
          <span>Các thang điểm của mức độ rủi ro phải liền tiếp nhau. Vui lòng kiểm tra lại.</span>
      </div>
      <template #footer>
          <Button type="button" label="Xác nhận" @click="showWarningPoints = false" />
      </template>
    </Dialog>

    <Dialog header="Rất cảnh báo" :visible.sync="popupWarning" >
      <h1 class="txt-center txt-required">HỆ THỐNG ĐANG PHÁT TRIỂN  !!!!!!!!!!!!!</h1>
    </Dialog>
  </form>
</template>

<script>
import DropdownScrollable from '@/components/DropdownScrollable.vue';
import ApiRepository from "@/core/ApiRepository";
import moment from "moment-timezone";
import pointComponent from "./components/points";
import matrixComponent from "./components/matrix";
export default {
  components:{
    DropdownScrollable,
    pointComponent,
    matrixComponent
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
    company_id: String
  },
  data() {
    return {
      filters: {},
      company: {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      time_zone_local : moment.tz.guess(true),
      list: [],
      formula: "R = ",
      value: "",
      tick_arr: [],
      criteria: [],
      type: "POINT",
      code_exist: [],
      points: [],
      matrix: [],
      criteria_id_col: null,
      criteria_id_row: null,
      warningPopup: false,
      count_total_select: null,
      popupWarning: false,
      componentKey: 0,
      listColor: [],
      dataColor: [],
      showWarningPoints: false
    };
  },
  async mounted() {
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
        setTimeout(() => {
          this.company = {id: this.$route.query.company_id};
          const query = Object.assign({}, this.$route.query);
          delete query.company_id;
          this.$router.replace({ query });
        }, 100);
      }
    }
    if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN){
      await this.getListCompany();
    } else {
      this.$set(this, 'company', {id: this.company_id});
    }
  },
  watch: {
    "count_total_select"() {
      console.log("count_total_select", this.count_total_select);
    },
    async "company"() {
      this.$emit("company", this.company?.id);
      await this.getListCriteria();
    },
    "company_id"(){
      this.resetForm();
    },
    "$props.model"() {
      if (!this.$commonFuction.isEmptyObject(this.model)) {
        this.points = this.model.points.map(m => {
          m.point_from = parseInt(m.point_from);
          m.point_to = parseInt(m.point_to);
          return m
        });
        this.matrix = this.model.matrix;
        this.type = this.model.dataValues.type;
        this.value = this.model.dataValues.value;
        this.dataColor = this.model.colors;
        if (!this.$commonFuction.isEmptyObject(this.model.dataValues.json_ids)) {
          for (const [i, m] of Object.entries(this.model.dataValues.json_ids)) {
            this.tick_arr[i] = m;
          }
          var arr_code = [];
          var code_exist = [];
          setTimeout(() => {
            var arr_ids = Object.keys(this.tick_arr);
            this.criteria.map(m => {
              if (arr_ids.includes(m.id)){
                if (this.tick_arr[m.id]) {
                  arr_code.push(m.code);
                  if (this.count_total_select < m.count_total) {
                    this.count_total_select = m.count_total;
                  }
                  var arr = m.id.split("*");
                  arr.map(n => {
                    if (!code_exist.includes(n)) {
                      code_exist.push(n);
                    }
                  })
                }
              }
            })
            this.code_exist = code_exist;
            if (arr_code.length > 0) {
              var code_str = arr_code.join(" + ");
              this.formula = `R = ${code_str}`;
            } else {
              this.formula = "R = ";
            }
          }, 100);
        }
        this.componentKey++;
      }
    },
    "type"(){
      this.criteria_id_col = null;
      this.criteria_id_row = null;
      this.listColor = [];
      this.componentKey++;
      console.log(this.type);
    },
  },
  methods: {
    matrixRowCol(data) {
      this.criteria_id_col = data?.criteria_id_col;
      this.criteria_id_row = data?.criteria_id_row;
    },
    matrixColor(data){
      this.listColor = data
    },
    resetForm() {
      this.list = [];
      this.formula = "R = ";
      this.tick_arr = [];
      this.criteria = [];
      this.type = "POINT";
      this.code_exist = [];
      this.points = [];
      this.matrix = [];
      this.listColor = [];
      this.criteria_id_col = null;
      this.criteria_id_row = null;
      this.value = null;
    },
    checkBoxEvent(item, e) {
      var arr_code = [];
      var arr_uid = [];
      var code_exist = [];
      this.count_total_select = 0;
      setTimeout(() => {
        var arr_ids = Object.keys(this.tick_arr);
        this.criteria.map(m => {
          if (arr_ids.includes(m.id)){
            if (this.tick_arr[m.id]) {
              arr_code.push(m.code);
              arr_uid.push(m.id);
              if (this.count_total_select < m.count_total) {
                this.count_total_select = m.count_total;
              }
              var arr = m.id.split("*");
              arr.map(n => {
                if (!code_exist.includes(n)) {
                  code_exist.push(n);
                }
              })
            }
          }
        })
        if (this.type == "MATRIX" && (code_exist.length != 2 || this.count_total_select > 5)) {
          setTimeout(() => {
            if (code_exist.length > 2 || this.count_total_select > 5) {
              e.target.removeAttribute('checked');
              this.tick_arr[item.id] = false;
            } else if (code_exist.length < 2) {
              e.target.setAttribute('checked', true);
              this.tick_arr[item.id] = true;
            }
          }, 100);
          this.warningPopup = true;
          return;
        }
        this.code_exist = code_exist;
        if (arr_code.length > 0) {
          var code_str = arr_code.join(" + ");
          this.formula = `R = ${code_str}`;
        } else {
          this.formula = "R = ";
        }
        this.value = arr_uid.join(" + ");
      }, 100);
    },
    backToList() {
      this.$emit("back");
    },
    async emitEvent(keyword) {
      this.$delete(this.filters, 'name');
      if (keyword) {
        this.filters.name = keyword;
      }
      await this.getListCompany();
    },
    async changeOffset(value) {
      this.offset = value;
      // await this.getListCompany();
    },
    async getListCriteria() {
      console.log(this.company);
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.criteria = [];
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.loading = true;
        await ApiRepository.post("/_api/criteria/options", {filters: {}, limit: 20, offset: this.offset, company_id: this.company.id}, {headers}).then((res) => {
            var list_tmp = [];
            var list = res.data.data.criteria;
            list.map((m) => {
              list_tmp.push({
                id: m.id,
                code: m.code,
                count_total: m.count_total
              })
            })
            this.getMatrix(list_tmp, list.length);
            this.loading = false;
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },
    isTrue(arr, arr2){
      return arr.every(i => arr2.includes(i));
    },
    getMatrix(list_tmp, size) {
      var change = 0;
      var code_arr_check = [];
      list_tmp.map((m) => {
        list_tmp.map((n) => {
          if (n.id != m.id) {
            if (!(n.id.split("*")).includes(m.id)) {
              var new_a = {
                id: `${m.id}*${n.id}`,
                code: `${m.code}*${n.code}`,
                count_total: (m.count_total < n.count_total) ? n.count_total : m.count_total,
              }
              new_a.count = new_a.id.split("*").length;
              var code_arr = new_a.id.split("*").sort().join("*");
              if (new_a.id.split("*").length <= size && !code_arr_check.includes(code_arr)) {
                code_arr_check.push(code_arr);
                list_tmp.push(new_a)
                change = 1;
              } else {
                change = 0;
              }
            }
          }
        })
      })
      list_tmp = list_tmp.sort((a, b) => a.count - b.count);
      if (change > 0) {
        return this.getMatrix(list_tmp, size);
      } else {
        this.criteria = list_tmp.sort((a, b) => a.count - b.count);
      }
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.filters, limit: 20, offset: this.offset}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.items.push(...res.data.data.company);
          } else {
            this.items = res.data.data.company;
          }
          this.total = res.data.data.total;
          this.loading = false;
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },
    async validateData() {
      this.validationErrors = {};
      if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
        let company_add = document.getElementById("company");
        if (
          this.$commonFuction.isEmptyObject(this.company) ||
          this.$commonFuction.isEmpty(this.company)
        ) {
          company_add.setCustomValidity("Công ty không được để trống!");
        } else {
          company_add.setCustomValidity("");
        }
      }

      let tick_add = document.getElementById("tick");
      if (
        this.$commonFuction.isEmpty(this.value)
      ) {
        tick_add.setCustomValidity("Công thức tính không được để trống!");
      } else {
        tick_add.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async saveData(recalculation=false) {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }
      var arr_ids = Object.keys(this.tick_arr);
      var tick_json = {};
      arr_ids.map(m => {
        tick_json[m] = this.tick_arr[m];
      })
      if (this.type == "POINT") {
        var errs = 0;
        var last_points = 0;
        this.points.map(m => {
          if (last_points != 0 && (last_points != m.point_from)) {
            errs++;
          }
          last_points = parseInt(m.point_to)+1;
        })
        if (errs > 0) {
          this.showWarningPoints = true;
          this.$commonFuction.is_loading(false);
          return;
        }
      }
      var params = {
        value: this.value,
        tick_arr: tick_json,
        type: this.type,
        code_exist: this.code_exist,
        points: this.type == "POINT" ? this.points : [],
        matrix: this.type == "MATRIX" ? this.matrix : [],
        criteria_id_col: this.criteria_id_col,
        criteria_id_row: this.criteria_id_row,
        colors: this.listColor,
        company: this.company,
        recalculation : recalculation
      };
      this.$emit("save", params);
      // }
    }
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-checkbox, .p-radiobutton.p-component{
  margin-right: 1rem !important;
}
.txt-last-update {
  color: #666666;
  font-size: calc(16px*0.8);
}
.ml-4-5{
    margin-left: 2.5rem !important;
}
.p-radiobutton-disabled, .p-inputtext[disabled='disabled'] {
  cursor: no-drop;
}
#warning_poins_errs .p-dialog-footer{
  justify-content: center;
}
</style>
